import type { GicsLevel } from "../types.ts";
import { GicsLevelBadge } from "./GicsLevelBadge.tsx";

interface GicsClassificationItem {
  name: string;
  code: string;
}

export interface GicsClassification {
  sector: GicsClassificationItem;
  industryGroup: GicsClassificationItem;
  industry: GicsClassificationItem;
  name: string;
  code: string;
}

interface GicsClassificationDisplayProps {
  classification: GicsClassification;
  className?: string;
}

interface LevelBadgeWithLabelProps {
  level: GicsLevel;
  name: string;
  code: string;
}

function LevelBadgeWithLabel({ level, name, code }: LevelBadgeWithLabelProps) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <GicsLevelBadge level={level} />
      <span>{name}</span>
      <span className="text-xs opacity-70">({code})</span>
    </span>
  );
}

export function GicsClassificationDisplay({
  classification,
  className,
}: GicsClassificationDisplayProps) {
  return (
    <div className={className ?? "flex flex-wrap gap-2"}>
      <LevelBadgeWithLabel
        level={1}
        name={classification.sector.name}
        code={classification.sector.code}
      />
      <LevelBadgeWithLabel
        level={2}
        name={classification.industryGroup.name}
        code={classification.industryGroup.code}
      />
      <LevelBadgeWithLabel
        level={3}
        name={classification.industry.name}
        code={classification.industry.code}
      />
      <LevelBadgeWithLabel
        level={4}
        name={classification.name}
        code={classification.code}
      />
    </div>
  );
}
